import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

export const supervisorListGet = createAsyncThunk('supervisors', async (params) => {
  return await apiInstance.get('/supervisors', { params });
});

export const supervisorGetById = createAsyncThunk('supervisors/id', async (id) => {
  return await apiInstance.get(`/supervisors/${id}`);
});

export const supervisorAdd = createAsyncThunk('supervisors/add', async (payload) => {
  return await apiInstance.post('/supervisors', payload);
});

export const supervisorUpdate = createAsyncThunk('supervisors/update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/supervisors/${id}`, rest);
});

export const supervisorDelete = createAsyncThunk('supervisors/delete', async (id) => {
  return await apiInstance.delete(`/supervisors/${id}`);
});

export const supervisorOptionGet = createAsyncThunk('supervisors/supervisors-options', async () => {
  return await apiInstance.get('/supervisors');
});

export const supervisorOptionAllGet = createAsyncThunk(
  'supervisors/supervisor-Role-options',
  async () => {
    return await apiInstance.get('/supervisor-Role');
  }
);

export const supervisorRoleListGet = createAsyncThunk('supervisor-Role', async (params) => {
  return await apiInstance.get('/supervisor-Role', { params });
});

export const supervisorRoleGetById = createAsyncThunk('supervisor-Role-byId', async (id) => {
  return await apiInstance.get(`/supervisor-Role/${id}`);
});

export const supervisorRoleAdd = createAsyncThunk('supervisor-Role/add', async (payload) => {
  return await apiInstance.post('/supervisor-Role', payload);
});

export const supervisorRoleUpdate = createAsyncThunk('supervisor-Role/update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/supervisor-Role/${id}`, rest);
});

export const supervisorRoleDelete = createAsyncThunk('supervisor-Role/delete', async (id) => {
  return await apiInstance.delete(`/supervisor-Role/${id}`);
});

const initialState = {
  supervisorList: null,
  supervisorRoleList: null,
  isCallModalOpen: false
};

const supervisorSlice = createSlice({
  name: 'supervisor',
  initialState,
  reducers: {
    clearSupervisorSlice: () => initialState,
    setCallModalOpen(state, action) {
      state.isCallModalOpen = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(supervisorListGet.fulfilled, (state, action) => {
      state.supervisorList = action?.payload;
    });
    builder.addCase(supervisorRoleListGet.fulfilled, (state, action) => {
      state.supervisorRoleList = action?.payload;
    });
  }
});

export default supervisorSlice.reducer;
export const { clearSupervisorSlice, setCallModalOpen } = supervisorSlice.actions;

export const selectSupervisorList = (state) => state.supervisor.supervisorList;
export const useSupervisorList = () => {
  const supervisorList = useSelector(selectSupervisorList);
  return useMemo(() => supervisorList, [supervisorList]);
};

export const selectSupervisorRoleList = (state) => state.supervisor.supervisorRoleList;
export const useSupervisorRoleList = () => {
  const supervisorRoleList = useSelector(selectSupervisorRoleList);
  return useMemo(() => supervisorRoleList, [supervisorRoleList]);
};

export const selectIsCallModalOpen = (state) => state.supervisor.isCallModalOpen;
export const useIsCallModalOpen = () => {
  const isCallModalOpen = useSelector(selectIsCallModalOpen);
  return useMemo(() => isCallModalOpen, [isCallModalOpen]);
};
